import { render, staticRenderFns } from "./GoodsList2.vue?vue&type=template&id=bbfee4f8&scoped=true&"
import script from "./GoodsList2.vue?vue&type=script&lang=js&"
export * from "./GoodsList2.vue?vue&type=script&lang=js&"
import style0 from "./GoodsList2.vue?vue&type=style&index=0&id=bbfee4f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfee4f8",
  null
  
)

export default component.exports